"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.FileInputButton = void 0;

var _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require("prop-types"),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _officeUiFabricReact = require("office-ui-fabric-react");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var tokens = {
  childrenGap: 10
},
    FileInputButton = exports.FileInputButton = function (a) {
  var b = a.onClick,
      c = a.text,
      d = a.fileInputRef,
      e = a.accept,
      f = a.onChange,
      g = a.disabled,
      h = a.multiple,
      i = a.iconName;
  return _react2.default.createElement(_officeUiFabricReact.Stack, {
    horizontal: !0,
    tokens: tokens
  }, _react2.default.createElement(_officeUiFabricReact.Stack.Item, null, _react2.default.createElement("input", {
    type: "file",
    ref: d,
    hidden: !0,
    accept: e,
    onChange: f,
    disabled: g,
    multiple: h
  }), _react2.default.createElement(_officeUiFabricReact.Button, {
    primary: !0,
    onClick: b,
    text: c,
    disabled: g,
    iconProps: {
      iconName: i
    }
  })));
};

FileInputButton.propTypes = {
  /** event-handler for the button */
  onClick: _propTypes2.default.func,

  /** the `Button` text/label */
  text: _propTypes2.default.string,

  /**
  The ref that will be passed to file-input
  */
  fileInputRef: _propTypes2.default.shape({
    current: _propTypes2.default.any
  }).isRequired,

  /**
  The `file-types` you want to allow for uploading
  */
  accept: _propTypes2.default.string,

  /**
  The event-handler for the file-input
  - it is executed when the file is selected
  */
  onChange: _propTypes2.default.func,

  /**
  Enable/disable the `FileInputButton`
  */
  disabled: _propTypes2.default.bool,

  /**
  `true` to upload multiple files
  */
  multiple: _propTypes2.default.bool,

  /**
  The Icon for the Button
  */
  iconName: _propTypes2.default.string
}, FileInputButton.defaultProps = {
  onClick: function a() {},
  onChange: function a() {},
  text: "Upload",
  accept: "image/*",
  disabled: !1,
  multiple: !1,
  iconName: "Upload"
}, exports.default = _react2.default.memo(FileInputButton);